<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 17 17">
    <path
      d="M5.25015 5.2501L11.7504 11.7504M5.25015 11.7504L11.7504 5.2501"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconClose',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  fill: none;
  flex-shrink: 0;
}
</style>
